"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getExponentValue(value) {
    return parseInt(value, 10);
}
exports.getExponentValue = getExponentValue;
exports.negateExponent = function (value) { return toExponent(-getExponentValue(value)); };
exports.addExponents = wrapBinaryExponentFn(function (left, right) { return left + right; });
exports.multiplyExponents = wrapBinaryExponentFn(function (left, right) { return left * right; });
exports.divideExponents = wrapBinaryExponentFn(function (left, right) { return left / right; });
function wrapBinaryExponentFn(fn) {
    return function (left, right) { return toExponent(fn(getExponentValue(left), getExponentValue(right))); };
}
function toExponent(value) {
    return "" + value;
}
//# sourceMappingURL=exponentValueArithmetic.js.map